module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("M")])]), _vm._v("ac had almost missed him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In a hurry to get back into his civilian attire so he could get home in time for his date, Mac had walked right by the supply closet and almost missed the sound entirely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t as if there was no other noise within the area. Even an E.R. at rest still hummed with the regular sounds of human activity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But this sound was different.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was whimpering—like a small, wounded animal that was afraid of being found.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac stopped, listening for a direction, a source to the sound and abruptly realized that he had walked right by it without knowing it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Backtracking, he paused before the supply door, listening more closely.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Debating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If he was wrong, if the sound he heard wasn’t the kind caused by fear but instead a little squeal of pleasure escaping, then he would be intruding on territory he himself had traversed more than once. Within each hospital there were little out of the way pockets to which members of the staff occasionally escaped whenever they found themselves being drawn together by feelings that couldn’t be put on hold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He listened intently. No noise. Maybe he’d been mistaken after all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac was all set to chalk the whole thing up to his imagination when the sound came again, this time even more muffled than before. Even more distressed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not his imagination, he thought. He just hoped he wasn’t about to walk in on something he shouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Holding his breath, Mac slowly eased the door open and took a quick look inside the unlit, almost airless enclosure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At first glance, there appeared to be no one there. Only shelves of neatly stacked bed linens and blankets crowding against one another.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then he saw him. A little boy of no more than about five. If he was six, it was a particularly small six.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boy was huddled on the floor in the far corner of the closet, his head buried in a towel, the towel firmly pressed against his knees.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, that would explain the muffled sound, Mac thought. But not what the boy was doing there in the first place.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Mac glanced again at his watch. Minutes were melting away and so was his safety margin. At this ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("rate, there wasn’t going to be time for a shower. Probably the only thing he could manage would be to change his shirt. If he left now.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The debate whether to leave or to linger a few more minutes was over with in less than a heartbeat. There were more important things right now than getting a clean shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey partner,” Mac said softly, edging his way into the small area, “trying out our towels to see if they’re soft?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The small, dark head jerked up, then down again, as if the boy had remembered something and pressed his face against the towel again. He said nothing. Mac could have sworn the boy was trying to disappear into the very weave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Feeling the wall, Mac found the light and flipped it on, then closed the door behind him. He took a couple of more steps toward the boy, approaching him the way he might a frightened, wounded animal he didn’t want to scare away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, I get it. You’re the strong, silent type.” Standing in front of him now, Mac crouched down before the boy, who seemed to physically shrink away even further. “You know, you’re going to suffocate if you burrow any further into that towel.” Mac addressed his words to the top of the boy’s dark head. “I’m Dr. Mac. They let me play here sometimes. What’s your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no response.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac took it in stride. Shyness was not something new to him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“Nameless, huh? Okay, Nameless, I know there’s got to be someone looking for you so why don’t we ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("blow this Popsicle stand and get out where they’ve got a better chance of seeing you?”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still holding the towel to part of his face, the boy raised his head, allowing one dark eye to warily look up at Mac.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a bloodstain slowly coming through the corner of the towel closest to the boy’s face. The boy was hurt. Had he come in with the balcony victims and had somehow been missed?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac didn’t think that very likely. The youngest person treated from the party had been a nineteen-year-old. This one didn’t look old enough to spell “balcony,” much less be on one while a bunch of so-called adults did their best to emulate a frat house prank.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac deliberately kept his voice calm, cheery, knowing that anything less would send the boy withdrawing even further into himself. A traumatized patient was just that much harder to deal with.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He thought about his nephew and pretended he was talking to Kirby. His sister’s youngest had always been more than a handful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, I see an eye. Is there another one on the other side?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gently Mac began to coax the towel away from the boy’s face. The bandage that was barely resting against the little boy’s cheek had been applied by an amateur, very possibly the boy himself, and was about to come off any second. There was blood, both dried and fresh all along the small face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Whatever had happened, Mac judged, had happened fairly recently.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he reached for the bandage, the boy pulled back, his eyes wide, frightened. Mac waited a beat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“C’mon, Nameless, let me see. I’m a better doctor than I look.” His eyes met the boy’s and his tone softened even more. It was soft, comforting. Questions filled his head, but they could wait for a little while. “I won’t hurt you, I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boy whimpered again in fearful anticipation. He was shaking, Mac realized, but he didn’t shrink away this time and allowed himself to be examined.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t pretty. There was a four-inch jagged laceration running along his left cheek. It had just missed his eye.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac felt like someone had stuck a red-hot poker in his stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re not part of the people who just came in, are you?” he murmured. It was a rhetorical question. The boy stared at him with wide eyes. “No, I guess not.” An urge to hug the boy swept over Mac, but he knew that would only frighten him even more. No sudden moves, no matter how altruistic. “Did someone do this to you?” The boy’s silence answered Mac’s question for him. Had it been an accident, he was certain that the boy, frightened or not, would have volunteered the information. “Okay, come with me. We’re going to make you good as new.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac didn’t bother adding that the promise couldn’t be fulfilled immediately, that it would take some time and more than one operation to make things right, but those were details a frightened little boy didn’t need to hear right now. What he needed most was comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could do that much.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Very gently, he picked the boy up in his arms. ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Turning, Mac left the confines of the supply closet and walked out into the corridor.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The first person he saw was Nurse Icicle. It figured. But he didn’t have time to look around for someone else, someone he actually worked well with. The boy needed to have this tended to now, before an infection set in. If it hadn’t started to already.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reaching out, Mac caught her by the shoulder before the woman could continue hurrying away to another trauma room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jolene, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She recognized the voice immediately. Shrugging him off, she squeezed out a terse “Nurse DeLuca,” between her teeth as she turned around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And stopped dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes widened as she looked at the frightened little boy in Mac’s arms. Her mother’s heart twisted a little within her chest. A child in distress always got to her. “What happened to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not sure,” Mac replied glibly, then looked down at the small being he was holding against him, his voice comforting as he added, “but we’re going to undo it, right, Nameless?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jolene stared at the world-class Romeo in front of her, torn between her readiness to dislike him and what she saw. “You don’t even know his name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked around to see if there was a worried parent hovering around somewhere close by, but there were only the same players she’d been seeing for more than the last three hours.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one looked as if they’d lost anything but time and some skin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("He really, really didn’t care for her tone or the cool ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("way she regarded him. As if he’d gotten his degree from the back of a comic book. But now wasn’t the time to put her in her place or to even find out just what her problem actually was.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know he’s bleeding and needs help. Anything else we can look into later.” He nodded past the regular rows of beds within the E.R. kept for standard cases and toward the trauma rooms. “Are there any beds available down here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jolene thought for a second. “They just took two more up for surgery a few minutes ago. I think Trauma Room Two is free.” The victims had been doubled up by twos and threes, gurneys wheeled into the rooms serving as beds rather than just used for transport.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Room two it is,” he announced cheerfully to the boy who was now wrapped around him like a small gibbon monkey around a tree, holding on for dear life. Looking over the boy’s head, Mac lowered his voice. “I’d like your help, Nurse DeLuca—unless of course you have some icebergs you need to create.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jolene pressed her lips together, stifling the retort that had sprang up in response. “This way.” She turned on her crepe heel and quickly led the way to the room that Jorge had only now freshly sanitized.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once inside, she closed the door behind Mac, then hurried over to the bed as the boy was placed there. He began to whimper again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rather than step back the way she fully expected him to, she saw Mac take the boy’s hand in his.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("“It’s going to be all right, Nameless, I promise.” Mac carefully made the boy as comfortable as possible. “You know, you’re about my nephew’s age. ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("His name is Kirby.” He kept talking to the boy as if they were old friends, hoping to put him at ease. “Kind of a funny name for a kid, but I suspect he’ll grow into it. What do you think, Nameless? Think he will?”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boy took a deep breath, then let it slowly out again. His small chest quavered slightly. “Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Breakthrough,")]), _vm._v(" Mac thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked at the boy innocently. “You think he should be called Tommy?” Mac pretended to think the choice over. “Yeah, that’s a pretty cool name. Maybe I’ll ask him if he wants to change his name to Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” the boy contradicted softly. “My name.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac maintained a serious expression as he asked, “You want to change your name to Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the first time, there was a hint of a smile on the small boy’s face as he looked up at him. “No, my name "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah.” Nodding sagely at the revelation, Mac solemnly took the boy’s hand in his and shook it. “Glad to meet you, Tommy.” He inclined his head toward the boy. “I’ve got to admit that Tommy sounds a lot better than Nameless.” Still smiling, though this time it was purely for the boy’s benefit and not easy, Mac looked into the boy’s eyes. “Who did this to you, Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d been grudgingly giving him points for his behavior toward the boy, but the insensitive, not to mention possibly incorrect nature of the question had Jolene taking offense for the boy’s absent parents. “You can’t just assume—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("The woman was really beginning to get on his ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("nerves. Not even sparing her a glance, Mac held his hand up to silence her. His entire attention was focused on the boy. He needed to bridge this gap that existed between Tommy and the rest of the world.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can trust me, Tommy,” Mac assured him softly. “I’ll make sure it doesn’t happen to you again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A shaky sigh came from the boy’s lips and then he pressed them together before raising his eyes to Mac’s. His lower lip trembled, as if he was struggling against the urge to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was clear that he didn’t want to say anything, was afraid of saying something, whether because he thought he would be punished, or that something more dire would happen to him. To Mac, it didn’t matter. What mattered was that the boy was afraid and that he had been harmed. And that he never should be again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tommy seemed to search his face before lowering his eyes again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hugo,” the boy said so quietly that for a moment, it seemed to Mac that he’d imagined it. And then Tommy raised his head again, his eyes bright with unshed tears. “Am I gonna look like a monster?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally something he could control in this awful scenario. There was no hesitation in his voice whatsoever. “No, absolutely not, Tommy. You’re going to be the same good-looking guy you always were.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nurse DeLuca,” he uttered Jolene’s title deliberately, his smile never wavering for Tommy’s benefit, “do you think you can put your disdain for me on hold long enough to bring me a suturing tray?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("Without waiting for her affirmative reply, Mac ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("went on to enumerate the rest of the supplies he was going to need in order to begin the first phase of Tommy’s recovery.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d almost had her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Watching Harrison MacKenzie interacting with the boy, she’d almost been touched by his behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But then when he looked at her, every single warning signal in her body went on the alert. This was the arena she was accustomed to. Being treated like little more than a semiliterate lackey by a doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jolene stiffened her back automatically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Doctor,” was all she said in response as she turned on her heel. She went to retrieve the items he was going to need.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good as new,” Mac promised Tommy again as Jolene walked out, knowing that a child’s retention ability numbered in the seconds when it came to fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His sister Carrie had gone on to marry a successful stockbroker and along the way had provided him with two nephews and a niece. Mac had instantly evolved into a doting uncle. The trio had given him a broad learning spectrum from which he’d picked up a great deal more insight into dealing with kids than he’d gotten from either his child psychology courses and even his short rotation in pediatrics.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tommy wrapped his small fingers around Mac’s hand and nodded, his eyes if not trusting, at least a little hopeful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For now, it was the best Mac could ask for.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Wanda stuck her head in just as he was finishing up his work. She’d observed Jolene entering the room with a suture tray earlier. It was Wanda’s custom to ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("stay on top of the new personnel—be they doctors or nurses—when they joined her E.R. team until she was sure that were they were well integrated into the whole.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everything okay in here?” she asked cheerfully. And then her milk-chocolate complexion seemed to blanch when she saw the patient. “Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac stripped off his gloves, tossing them into the trash. He flashed a wide smile at the boy. “You know this trooper?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure I know him. This is Tommy Edwards.” There was an infinite amount of compassion in her eyes as she looked at the boy. “His mother, Jane, was a nurse here. One of my best.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That would explain why the boy had turned up here, Mac thought. He moved away from the boy and closer to Wanda. “Was?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wanda lowered her voice. That was a whole other story. “I’ll tell you later.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mom died,” the boy said with the on-target honesty of a child.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wanda came closer to the bed. She threaded her hand through the boy’s silky dark hair. Her heart ached just to look at him. “What happened, Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He sustained a laceration,” Mac said simply for the boy’s sake, avoiding technical terms that he knew would only frighten him. “He said Hugo did it.” Turning his back to the boy so he couldn’t hear, Mac took Wanda aside. “That his father?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Wanda shook her head. It was a sad story all around. “He doesn’t have a father, he’s got a stepfather. His father left before the boy was born. Step")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("father’s name is Paul Allen.” She’d heard that the man wasn’t happy being saddled with Tommy’s welfare now that the boy’s mother was dead. Wanda stopped to think. “I think Jane mentioned a dog named Hugo. A Doberman. Said she didn’t like having the dog around, but that Paul was adamant about keeping it.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man’s exact words had been that he’d sooner get rid of the boy than the dog, but that wasn’t something Wanda was about to repeat around Tommy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned around again and looked at Tommy. He looked pale, even against the fresh bandage that was covering his sutures. “Honey, why didn’t you come to me when this happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tried,” he mumbled to the tips of his sneakers as he looked at them. “Couldn’t find you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, now you found me,” Wanda declared. “And we’re going to find your stepdad.” Even if she had to haul him out of whatever hole he was residing in, Wanda added silently. About to pick up the boy, she looked at Mac. “Are you through with him, Doctor?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For now.” Turning his head, he lowered his voice, “He’s going to need reconstructive surgery on that once the wound heals.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wanda nodded as she pressed her lips together. “Getting Allen’s consent isn’t going to be easy. Especially not after I strangle that dog of his with my bare hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My money’s on you, Wanda,” Mac told her, grinning.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Wanda merely laughed in response. “C’mon, ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Tommy. Let’s see if there’s any ice cream in the refrigerator for a brave boy.”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She scooped the boy up into her arms, holding him to her ample chest. The boy curled up against her, responding to the maternal warmth he felt emanating from his mother’s friend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes met Mac’s over Wanda’s shoulder just before he was carried out from the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bye,” he said solemnly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not bye,” Mac corrected him. “‘So-long.’ I’ll be seeing you again soon. Sure you don’t like being called Nameless better?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boy giggled and shook his head slightly. “I’m sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac grinned at him. “Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Wanda stepped out of the room with his patient, Mac peeled off the yellow paper gown he’d put on and turned to toss it into the wastebasket where he’d thrown away his gloves. He could feel the other nurse’s eyes all but boring into him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That woman was a knockout, but she could definitely stand to have an attitude adjustment. Too bad he was too tired to do anything about it right now. “Something you want to say to me, Nurse DeLuca?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t tell if he was being sarcastic or distant. In either case, it didn’t matter. She wasn’t here to strike up friendships with the doctors. But she was big enough to admit when she was wrong. And she had been, at least as far as this went.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were good with that little boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned to face her squarely. “Why, did you expect me to torture him?”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was already regretting her mellower stance. “No, I just expected you to be a doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mac stood studying her for a moment, trying to make sense of what she’d just said. He failed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is that some kind of code? Because I was being a doctor. Stethoscope, sutures, Novocain,” he went down the line of things he’d used in cleaning out, then stitching the wound. “The works.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I mean you were kind to him.” Most of the doctors she’d worked with were interested in doing their job, applying their knowledge, and then moving on. After four years, she’d begun to believe that was the nature of the beast.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still lost, Mac could only stare at her. “Just what kind of doctors do you know, Nurse DeLuca? Dr. Frankenstein and his crowd?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was making fun of her. She might have known. Served her right for entertaining charitable thoughts about him. “Never mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” he caught her arm as she began to leave the room. “You started this, I’m curious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blowing out a breath, Jolene resigned herself to remaining where she was until the doctor heard what he wanted to hear. “I’m accustomed to doctors who treat the wound, not the patient.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was watching her eyes. She looked directly at him. People who fabricated things looked away. Either she was very, very good, or she was telling the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When you hear hoofbeats, he reminded himself, think horse, not zebra.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He thought zebra.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So that’s why you transferred.”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jolene had learned that being closemouthed was a great deal safer than sharing bits and pieces of yourself. Because bits and pieces could be reconstructed to be used against you, or tossed away carelessly. She wasn’t sure which was worse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she’d just witnessed him being exceptionally gentle with the boy, the way she would have been had MacKenzie acted like a typical doctor in her mind toward the boy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So she shrugged and gave him an answer of sorts. “Among other reasons.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was mellowing, he thought. And he had to admit that he liked it. His initial reaction toward Jolene shuffled forward to take the center stage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe you can tell me about those other reasons over coffee later if you’re not busy—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am.” Just because she was being civil to him didn’t mean she wanted to sit at the same table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d answered just a little too quickly for him. “You don’t know when later.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Doesn’t matter,” she informed him crisply. “I intend to be busy until the next century.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was about to counter that assessment, but his pager went off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tilted the small gray/blue device toward him and recognized the phone number as one he’d dialed only last night. Lynda. Somehow, she’d managed to completely slip his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Damn, I forgot all about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Curious, Jolene looked down at the LCD scene with its numbers that meant nothing to her. The question came without thought. “Forgot about what?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("Mac sighed. He was supposed to have picked the ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("woman up at her place twenty minutes ago. “My date.”")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reaching into his pocket for his cell phone, Mac turned toward Jolene to finish their conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she was already gone.")])])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page37"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dea1432","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426870347_ch02.vue
// module id = 81
// module chunks = 0